import { DESTINATION_COMP } from './../destination.consts';
import { NotificationService } from './../../../common/services/notification/notification.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ApiService } from './../../../api/api.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import store from './../../../store/store.module';
import { SELECT_DESTINATION_TYPE, FETCH_DESTINATION_DETAIL_REQUESTED, UPDATE_DESTINATION_REQUESTED } from './edit.action';
import { Subscription } from 'rxjs/Subscription';
import { DELETE_DESTINATION_REQUESTED } from '../list/list.action';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit, OnDestroy {
  navigationSubscription: Subscription;
  public store = store;

  public destination = {};

  constructor(private api: ApiService, private route: ActivatedRoute, private notification: NotificationService, private router: Router) {
    this.navigationSubscription = this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.getDestination();
      }
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }

  private getDestination(): void {
    let id = this.route.snapshot.paramMap.get('id');
    store.dispatch({ type: FETCH_DESTINATION_DETAIL_REQUESTED, data: id });
  }

  onSubmit(form): void {
    let destination = (store as any).getState().Destination.edit.data;
    let data = {
      id: destination.getId(),
      code: destination.getCode(),
      destination_type_id: destination.getDestinationType().getId()
    };
    store.dispatch({ type: UPDATE_DESTINATION_REQUESTED, data: data });
  }

  deleteDestination(destination) {
    store.dispatch({
      type: DELETE_DESTINATION_REQUESTED,
      data: destination.getId(),
      com: DESTINATION_COMP
    });
  }
}
